import type { TransformMetadataResult } from '@post-office/universal-contracts/message-template-metadata';

import {
	type AnyPayload,
	type BackendSyncMessageStage,
} from '../../../../../create-placement/types';

export const defaultTransformMetadata: BackendSyncMessageStage<
	AnyPayload,
	TransformMetadataResult
> = () => ({
	goalMetadata: {
		primaryGoal: {
			goalId: 'clickthrough',
		},
	},
});
